export const storageReasonOptions = [
  { id: 17, name: "Avaliar devolução" },
  { id: 19, name: "Waste Devolução para o seller" },
  { id: 3, name: "Waste operacional" },
  { id: 28, name: "Movimentação ceasa" }
];
